import React, { useState, useEffect, useRef } from "react";
import Loading from "../../../../Extra/Loading";

import {
  getCurrentDate,
  minutesToHHMM,
  getCurrentMonthFirstDate,
} from "../../../../Utilitie";

const timeToSeconds = (t) => {
  if (!t || typeof t !== "string") return 0;
  const [h, m, s] = t.split(":").map(Number);
  return h * 3600 + m * 60 + s;
};

const secondsToHHMMSS = (sec) => {
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  return [h, m, s].map((v) => v.toString().padStart(2, "0")).join(":");
};

const AgreedAndGivenBlockCustom = ({ data }) => {
  ///////////////////

  const transformData = (data) => {
    const result = [];

    const grouped = {};

    for (const row of data) {
      if (!row || !row.reportDate) continue;

      const reportDate = row.reportDate.split("T")[0];
      const direction = row.Direction || "UNKNOWN";
      const section = row.section || "UNKNOWN";

      if (!grouped[direction]) grouped[direction] = {};
      if (!grouped[direction][section]) grouped[direction][section] = {};
      if (!grouped[direction][section][reportDate]) {
        grouped[direction][section][reportDate] = {
          reportDate,
          No_Of_Demand_By_Engg_tot: 0,
          No_Of_Demand_Agreed_GIVEN_tot: 0,
          Agreed_Demand_tot: 0,
          Engg_Demand_tot: 0,
          GrantedFrom_tot: 0,
          GrantedTo_tot: 0,
          Granted_Duration_tot: 0,
          Availed_From_tot: 0,
          Availed_To_tot: 0,
          Availed_tot: 0,
          Rated_Output_tot: 0,
          Actual_Output_tot: 0,
          Granted_not_tot: 0,
          Availed_Not_tot: 0,
          Burst_tot: 0,
          Burst_Duration_tot: 0,
        };
      }

      const target = grouped[direction][section][reportDate];

      target.No_Of_Demand_By_Engg_tot += Number(row.No_Of_Demand_By_Engg) || 0;
      target.No_Of_Demand_Agreed_GIVEN_tot +=
        Number(row.No_Of_Demand_Agreed_GIVEN) || 0;
      target.Agreed_Demand_tot += timeToSeconds(row.Agreed_Demand);
      target.Engg_Demand_tot += timeToSeconds(row.Engg_Demand);
      target.GrantedFrom_tot += timeToSeconds(row.GrantedFrom);
      target.GrantedTo_tot += timeToSeconds(row.GrantedTo);
      target.Granted_Duration_tot += timeToSeconds(row.Granted_Duration);
      target.Availed_From_tot += timeToSeconds(row.Availed_From);
      target.Availed_To_tot += timeToSeconds(row.Availed_To);
      target.Availed_tot += timeToSeconds(row.Availed);
      target.Rated_Output_tot += Number(row.Rated_Output) || 0;
      target.Actual_Output_tot += Number(row.Actual_Output_in_Meter) || 0;
      target.Granted_not_tot += row.Granted_Not ? 1 : 0;
      target.Availed_Not_tot += row.Availed_Not ? 1 : 0;
      target.Burst_tot += row.Burst ? 1 : 0;
      target.Burst_Duration_tot += timeToSeconds(row.Burst_Duration);
    }

    // Convert grouped object into required array structure
    for (const direction in grouped) {
      const sections = [];

      for (const section in grouped[direction]) {
        const dates = Object.values(grouped[direction][section]);
        sections.push({ section, data: dates });
      }

      result.push({ Direction: direction, children: sections });
    }

    return result;
  };

  ///////////////////
  const [nestedData, setNestedData] = useState([]);
  useEffect(() => {
    if (data) {
      const compliedData = transformData(data);
      setNestedData(compliedData);
    }
  }, [data]);
  //   useEffect(() => {
  //     if (!data1 || data1.length === 0) return;

  //     const grouped = {};

  //     data1.forEach((item) => {
  //       const { Direction, section, reportDate, Sno, From_Station, ...rest } =
  //         item;

  //       const formattedDate = new Date(reportDate).toISOString().split("T")[0];
  //       const dataEntry = {
  //         reportDate: formattedDate,
  //         ...rest,
  //       };

  //       if (!grouped[Direction]) {
  //         grouped[Direction] = {};
  //       }

  //       if (!grouped[Direction][section]) {
  //         grouped[Direction][section] = [];
  //       }

  //       grouped[Direction][section].push(dataEntry);
  //     });

  //     const finalOutput = Object.entries(grouped).map(
  //       ([direction, sections]) => ({
  //         Direction: direction,
  //         children: Object.entries(sections).map(([sectionName, dataArray]) => ({
  //           section: sectionName,
  //           data: dataArray,
  //         })),
  //       })
  //     );

  //     setNestedData(finalOutput);
  //   }, [data1]);

  //   const compiledData = {};
  //   const dates = new Set(
  //     nestedData.map((obj) => {
  //       [];
  //       obj.children.map((directionChild) => {
  //         directionChild.data.map((sec) => sec.reportDate);
  //       });
  //     })
  //   );

  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const tableRef = useRef();

  const [loading, setLoading] = useState(false);

  const availableDirections = nestedData.map((d) => d.Direction);
  const [selectedDirections, setSelectedDirections] = useState(new Set());

  useEffect(() => {
    const available = nestedData.map((d) => d.Direction);
    setSelectedDirections(new Set(available));
  }, [nestedData]);

  const toggleDirection = (direction) => {
    setSelectedDirections((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(direction)) {
        newSet.delete(direction);
      } else {
        newSet.add(direction);
      }
      return newSet;
    });
  };

  const uniqueDates = new Set();
  const columns = [];
  const flatData = {};

  nestedData.forEach((directionGroup) => {
    const { Direction, children: sections } = directionGroup;

    if (!selectedDirections.has(Direction)) return;

    sections.forEach((section) => {
      const { section: sectionName, data: demandData } = section;
      const key = `${sectionName}-${Direction}`;

      let cumgiven = 0;
      let cumAgreed = 0;

      demandData
        .sort((a, b) => new Date(a.reportDate) - new Date(b.reportDate))
        .forEach(({ reportDate, Availed_tot, Agreed_Demand_tot }) => {
          uniqueDates.add(reportDate);

          const given = parseFloat(Availed_tot) || 0;
          const agreed = parseFloat(Agreed_Demand_tot) || 0;
          const percentage = agreed
            ? ((given / agreed) * 100).toFixed(2)
            : "0.00";

          if (!flatData[reportDate]) flatData[reportDate] = {};
          flatData[reportDate][`${key}-Given`] = given;
          flatData[reportDate][`${key}-Agreed`] = agreed;
          flatData[reportDate][`${key}-Percentage`] = percentage;

          cumgiven += given;
          cumAgreed += agreed;
          const cumPercent = cumAgreed
            ? ((cumgiven / cumAgreed) * 100).toFixed(2)
            : "0.00";

          flatData[reportDate][`${key}-Cumulative`] = cumPercent;

          if (!columns.includes(`${key}-Given`)) columns.push(`${key}-Given`);
          if (!columns.includes(`${key}-Agreed`)) columns.push(`${key}-Agreed`);
          if (!columns.includes(`${key}-Percentage`))
            columns.push(`${key}-Percentage`);
          if (!columns.includes(`${key}-Cumulative`))
            columns.push(`${key}-Cumulative`);
        });
    });
  });

  const sortedDates = Array.from(uniqueDates).sort();

  return (
    <div>
      <div className="d-flex justify-content-between bg-dark text-white p-1 papaDiv">
        <h5 className="">Agreed and given block section wise </h5>
      </div>

      <div className="table-responsive position-relative">
        <table
          ref={tableRef}
          className=" table table-bordered table-striped mb-4 papaDiv "
          style={{ fontSize: "12px" }}
        >
          <thead className="table-dark align-middle">
            <tr>
              <th className="sticky-col" rowSpan={3}>
                Date
              </th>
              {Array.from(selectedDirections).map((dir) => {
                const sections =
                  nestedData.find((d) => d.Direction === dir)?.children || [];
                const sectionCount = sections.length;
                return (
                  <th key={dir} colSpan={sectionCount * 4}>
                    {dir}
                  </th>
                );
              })}
            </tr>

            <tr>
              {Array.from(selectedDirections).flatMap((dir) => {
                const sections =
                  nestedData.find((d) => d.Direction === dir)?.children || [];
                return sections.map((section) => (
                  <th key={`${dir}-${section.section}`} colSpan={4}>
                    {section.section}
                  </th>
                ));
              })}
            </tr>

            <tr>
              {Array.from(selectedDirections).flatMap((dir) => {
                const sections =
                  nestedData.find((d) => d.Direction === dir)?.children || [];
                return sections.flatMap(() => (
                  <React.Fragment>
                    <th>Agreed</th>

                    <th>given</th>
                    <th className="text-wrap">% of block given</th>
                    <th className="text-wrap">Cumulative %</th>
                  </React.Fragment>
                ));
              })}
            </tr>
          </thead>

          <tbody>
            {sortedDates.map((date) => (
              <tr key={date}>
                <td
                  className="sticky-col"
                  style={{
                    background: "rgba(173, 172, 172, 1)",
                    fontWeight: "bold",
                  }}
                >
                  {date}
                </td>
                {Array.from(selectedDirections).flatMap((dir) => {
                  const sections =
                    nestedData.find((d) => d.Direction === dir)?.children || [];
                  return sections.flatMap((section) => {
                    const key = `${section.section}-${dir}`;
                    return (
                      <React.Fragment>
                        <td>
                          {minutesToHHMM(
                            (flatData[date]?.[`${key}-Agreed`] ?? 0) / 60,
                            true
                          )}
                        </td>
                        <td>
                          {minutesToHHMM(
                            (flatData[date]?.[`${key}-Given`] ?? 0) / 60,
                            true
                          )}
                        </td>

                        <td>{flatData[date]?.[`${key}-Percentage`] ?? "-"}</td>
                        <td>{flatData[date]?.[`${key}-Cumulative`] ?? "-"}</td>
                      </React.Fragment>
                    );
                  });
                })}
              </tr>
            ))}
            <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" }}>
              <td
                className="sticky-col "
                style={{
                  background: "rgba(173, 172, 172, 1)",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                Total
              </td>
              {Array.from(selectedDirections).flatMap((dir) => {
                const sections =
                  nestedData.find((d) => d.Direction === dir)?.children || [];
                return sections.flatMap((section) => {
                  const key = `${section.section}-${dir}`;
                  let totalAgreed = 0;
                  let totalGiven = 0;

                  sortedDates.forEach((date) => {
                    totalAgreed += flatData[date]?.[`${key}-Agreed`] || 0;
                    totalGiven += flatData[date]?.[`${key}-Given`] || 0;
                  });

                  return (
                    <React.Fragment>
                      <td>{minutesToHHMM(totalAgreed / 60, true)}</td>
                      <td>{minutesToHHMM(totalGiven / 60, true)}</td>
                      <td>-</td>
                      <td>-</td>
                    </React.Fragment>
                  );
                });
              })}
            </tr>
          </tbody>
        </table>
        {loading && <Loading />}
      </div>
    </div>
  );
};

export default AgreedAndGivenBlockCustom;
